import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatStepperModule} from '@angular/material/stepper';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {map, startWith} from 'rxjs/operators';
// import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { MatPaginatorModule } from '@angular/material/paginator';


@NgModule({
    exports: [
        MatDatepickerModule,
        MatNativeDateModule,
        MatCardModule,
        MatFormFieldModule,
        MatChipsModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatIconModule,
        MatProgressBarModule,
        MatButtonModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        MatDialogModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatPaginatorModule
    ]
})
export class AppMaterialModule { }